import React from "react";
import { Link } from "react-router-dom";
import LOGO from "../../assets/images/black_logo.svg";

// Shown when a listing is missing, disabled, or still in review (i.e. not
// publicly visible). Self-contained so it can be dropped into any page that
// fails to load a valid listing.
const BRAND = "#F39C12";

export default function NotFound({
  title = "This listing isn’t available",
  message = "The stay you’re looking for may have been removed, paused, or isn’t live yet. But there are plenty more waiting to be discovered.",
}) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <img src={LOGO} alt="Roamhome" style={styles.logo} />

        <div style={styles.codeWrap}>
          <span style={styles.code}>4</span>
          <span style={{ ...styles.code, color: BRAND }}>0</span>
          <span style={styles.code}>4</span>
        </div>

        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>

        <div style={styles.actions}>
          <Link to="/" style={{ ...styles.btn, ...styles.btnPrimary }}>
            Back to home
          </Link>
          <Link to="/listings" style={{ ...styles.btn, ...styles.btnGhost }}>
            Browse stays
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem 1.25rem",
    background:
      "radial-gradient(circle at 50% 0%, rgba(243,156,18,0.08), transparent 60%)",
  },
  card: {
    maxWidth: "560px",
    width: "100%",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    height: "34px",
    marginBottom: "2.5rem",
    opacity: 0.9,
  },
  codeWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    marginBottom: "1.5rem",
  },
  code: {
    fontSize: "clamp(5rem, 18vw, 9rem)",
    fontWeight: 800,
    color: "#1a1a1a",
    letterSpacing: "-0.04em",
  },
  title: {
    fontSize: "clamp(1.4rem, 4vw, 1.9rem)",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: "0 0 0.75rem",
  },
  message: {
    fontSize: "1rem",
    lineHeight: 1.6,
    color: "#6b6b6b",
    margin: "0 0 2.25rem",
    maxWidth: "440px",
  },
  actions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.875rem",
    justifyContent: "center",
  },
  btn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.75rem 1.75rem",
    borderRadius: "10px",
    fontSize: "0.95rem",
    fontWeight: 600,
    textDecoration: "none",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },
  btnPrimary: {
    background: BRAND,
    color: "#fff",
    boxShadow: "0 8px 20px rgba(243,156,18,0.28)",
  },
  btnGhost: {
    background: "transparent",
    color: "#1a1a1a",
    border: "1.5px solid #e3e3e3",
  },
};
